import VisitCovidIconField from "./visits-covid-field";


const VisitFields = {
    CovidIcon : VisitCovidIconField
}

export default VisitFields;